import React, { useEffect } from 'react';
import Routes from './routes';
import getUserSession from '@utils/getSession';
import apiClient from '../api';
import { SELECTED_COMPANY_ID } from '../constants';
import '@pulsarml/avalon-ui/dist/style.css';
import 'ag-grid-community/styles/ag-grid.css'; // Mandatory CSS required by the grid
import '@pulsarml/avalon-ui/dist/ag-grid-custom-theme.css';
import { Logger } from '_clean-code/utils/logger';
import RefreshPageChecker from '@components/RefreshPageChecker';

const App = () => {
  useEffect(() => {
    document.addEventListener('click', postUserMetrics, false);
    return () => {
      document.removeEventListener('click', postUserMetrics, false);
    };
  }, []);
  return (
    <>
      <RefreshPageChecker />
      <Routes />
    </>
  );
};

export default App;

export async function postUserMetrics(event) {
  //const token = window.localStorage.getItem('React.AmplifyAuth');
  const { token } = await getUserSession().catch((err) => {
    Logger.info('Error getting user session for metrics', err);
    return { token: null };
  });
  if (!token) return;
  const node = event.target?.closest('[metric-target]');
  const metricTarget = node?.getAttribute('metric-target');

  apiClient
    .request(
      'POST',
      '/user-metrics',
      [{ metric: 'click', count: 1, target: metricTarget }],
      {
        headers: {
          Authorization: token,
          'Content-Type': 'application/json',
          'x-page': location.pathname + location.search + location.hash,
          'x-company-id': localStorage.getItem(SELECTED_COMPANY_ID) ?? ''
        }
      }
    )
    .catch((err) => {
      Logger.error('postUserMetrics: Error posting user metrics', err);
    });
}
